export default "__VITE_ASSET__cfd9cc25__"